<template>
  <section id="businessInfo">
    <div class="container">
      <div class="header">
        <h5>Business</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" class="infoForm" autocomplete="off">
        <h5>Tell us a bit about your business</h5>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="tradingName">
                Full Trading Name
                <span>*</span>
              </label>
              <input
                v-validate="'required'"
                v-model="tradingName"
                id="tradingName"
                class="input"
                name="Trading Name"
                type="text"
                required
              >
              <!-- <span>{{ errors.first('Trading Name') }}</span> -->
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="tradingAs">Known or Preferred Name (if Applicable)</label>
              <input v-model="tradingAs" id="tradingAs" class="input" type="text">
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third typeOfBussiness">
            <label for="businessType">
              Type of Business
              <span>*</span>
            </label>
            <div class="select">
              <select
                name="Bussiness Type"
                v-validate="'required'"
                v-model="businessType"
                id="businessType"
                required
              >
                <option value disabled>Select Option</option>
                <option value="Closed Corporation">Closed Corporation (CC)</option>
                <option value="Sole Proprioter">Sole Proprietor</option>
                <option value="PTY LTD">PTY LTD</option>
                <option value="Partnership">Partnership</option>
                <option value="Trust">Trust</option>
              </select>
            </div>
          </div>
          <div class="column is-one-third typeOfBussiness">
            <label for="businessNatureType">
              Nature of Business
              <span>*</span>
            </label>
            <div class="select">
              <select
                name="Bussiness Nature Type"
                v-validate="'required'"
                v-model="businessNatureType"
                id="businessNatureType"
                required
              >
                <option value disabled>Select Option</option>
                <option value="Engineering & Manufacturing">Engineering and Manufacturing</option>
                <option value="Building & Construction">Building and Construction</option>
                <option value="Painting Contractor">Painting Contractor</option>
                <option value="Shopfitting">Shopfitting</option>
                <option value="Hosp,School,Religious,Hotel">Hospital | School | Religious | Hotel</option>
                <option value="Body Corps & Prop Management">Body Corps and Property Management</option>
                <option value="Wholesaler & Retailer">Wholesaler and Retailer</option>
                <option value="Exporter">Exporter</option>
                <option value="Interior Decorator">Interior Decorator</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
          <div v-if="this.businessNatureType === 'Other'" class="column is-one-third ">
            <div class="control typeOfBussiness">
              <label for="compRegNum">
                Other Nature of Business
                <span>*</span>
              </label>
              <input
                v-model="businessNatureOtherType"
                v-validate="'required'"
                id="compRegNum"
                class="input"
                type="text"
                required
              >
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="vatRegNum">Vat Registration Number</label>
              <input
                v-model="vatRegNum"
                id="vatRegNum"
                class="input"
                type="number"
                required
              >
              <small>Leave blank if not VAT registered</small>
            </div>
          </div>
          <div v-if="businessType == 'Closed Corporation' || businessType == 'PTY LTD'" class="column is-one-third">
            <div class="control">
              <label for="compRegNum">
                Company Registration Number
                <span>*</span>
              </label>
              <input
                v-model="compRegNum"
                v-validate="'required'"
                id="compRegNum"
                class="input"
                type="number"
                
              >
            </div>
          </div>
          <div v-if="businessType == 'Trust'" class="column is-one-third">
            <div class="control">
              <label for="trustITnum">
                Trust IT Number
                <span>*</span>
              </label>
              <input
                v-model="trustITnum"
                v-validate="'required'"
                id="trustITnum"
                class="input"
                type="text"
                required
              >
            </div>
          </div>
        </div>
      </form>
      <!-- <div class="note column is-two-thirds b2bNotes">
      <p><b>Please Note:</b><br>
      As a Business to Business customer you will need to send us verification that you are a trade customer to activate your account. You'll get details on how to do this, and a list of accepted documents in your confirmation email. </p>
      </div> -->
      <div class="actions">
        <button @click="back()" class="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toBusinessNote()" class="button is-danger">Continue</button>
      </div>
    </div>
  </section>
</template>


<script>
import CancelButton from "../../components/actions/CancelButton";
import alertify from "alertifyjs";
export default {
  name: "businessInfo",
  data() {
    return {
      tradingName: null,
      tradingAs: null,
      businessType: null,
      businessNatureType: null,
      businessNatureOtherType: null,
      compRegNum: null,
      trustITnum: null,
      vatRegNum: null
    };
  },
  components: {
    CancelButton
  },
  methods: {
    toBusinessNote() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
        } else {
          this.$gtag.event('type_of_business', {
            'event_category': 'engagement',
            'event_label': this.businessType,
            'value': ''
          });
          this.$gtag.event('nature_of_business', {
            'event_category': 'engagement',
            'event_label': this.businessNatureType,
            'value': ''
          });
          this.$store.commit("STORE_BUSINESS_INFO", {
            tradingName: this.tradingName,
            tradingAs: this.tradingAs,
            businessType: this.businessType,
            businessNatureType: this.businessNatureType,
            businessNatureOtherType: this.businessNatureOtherType,
            compRegNum: this.compRegNum,
            trustITnum: this.trustITnum,
            vatRegNum: this.vatRegNum
          });
          this.$router.push("/businessNote");
        }
      });
    },
    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    }
  },
  mounted() {
    if (this.$store.state.isBusiness) {
      document.body.classList.add("isBusiness");
    }
    this.tradingName = this.$store.state.business.info.tradingName
    this.tradingAs = this.$store.state.business.info.tradingAs
    this.businessType = this.$store.state.business.info.businessType
    this.businessNatureType = this.$store.state.business.info.businessNatureType
    this.businessNatureOtherType = this.$store.state.business.info.businessNatureOtherType
    this.compRegNum = this.$store.state.business.info.compRegNum
    this.trustITnum = this.$store.state.business.info.trustITnum
    this.vatRegNum = this.$store.state.business.info.vatRegNum
  }
};
</script>
